export default "__VITE_ASSET__a3b3524e__"